import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=6bb1f4c5&scoped=true&"
import script from "./PaymentHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=6bb1f4c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb1f4c5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb1f4c5')) {
      api.createRecord('6bb1f4c5', component.options)
    } else {
      api.reload('6bb1f4c5', component.options)
    }
    module.hot.accept("./PaymentHistory.vue?vue&type=template&id=6bb1f4c5&scoped=true&", function () {
      api.rerender('6bb1f4c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/InvoiceRenderer/PaymentHistory.vue"
export default component.exports